<template>
    <span class="d-inline-block">
        <button type="button"
            :disabled="importing"
            v-on:click="importUsers"
            class="btn btn-rounded btn-primary btn-sm btn-icon mr-2">
            <template v-if="importing">
                <i class="material-icons">refresh</i>importing...
            </template>
            <template v-else>
                <i class="material-icons">get_app</i>Import Users
            </template>
        </button>
    </span>
</template>
<script>
import M from 'moment';
import { convertArrayToCSV } from 'convert-array-to-csv';

export default {
    data() {
        return {
            importing: false,
            // exportMode: 'keywords',
        }
    },

    props: [
        'content', 'config',
        'helpers', 'addNotification',
    ],

    computed: {

    },

    methods: {
        importUsers() {
            const api = this.helpers('api');
            this.importing = true;

            return api.runCommand('import:user-api')
                .then(() => this.importing = false);
        }
    }
}
</script>



// WEBPACK FOOTER //
// resources/assets/cms/js/components/ImportUserComponent.vue